import { PageRouteBuilder } from "@common/route/page-route-builder";
import { DeleteSurveyPageComponent } from "./delete-survey-page.component";

export const deleteSurveyPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-delete-survey-page", DeleteSurveyPageComponent)
    .requiresLogin()
    .atUrl("/tools/delete-survey")
    .withTitle("Delete Survey")
    .build();
